import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const originalVersionStoredFilterLabel = () => t({
    message: 'Original version stored',
    comment: 'Insights filter: Original version stored',
});
export function OriginalVersionStoredFilter() {
    return (<MetadataAllowedValuesFilter name="OriginalVersionStored" field="metadataDocumentOriginalVersionStored" label={originalVersionStoredFilterLabel()}/>);
}
